/**
 * 课程卡片模式切换
 */
export default {
  modeNames: {
    list: '리스트 모드',
    card: '카드 모드',
  },
}
